/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Nav_Cargos_DescriptionInputs */

const en_inventory_nav_cargos_description = /** @type {(inputs: Inventory_Nav_Cargos_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage cargo inventory and pricing`)
};

const es_inventory_nav_cargos_description = /** @type {(inputs: Inventory_Nav_Cargos_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar inventario y precios de cargas`)
};

/**
* | output |
* | --- |
* | "Manage cargo inventory and pricing" |
*
* @param {Inventory_Nav_Cargos_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_nav_cargos_description = /** @type {((inputs?: Inventory_Nav_Cargos_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Nav_Cargos_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_nav_cargos_description(inputs)
	return es_inventory_nav_cargos_description(inputs)
});